import { render, staticRenderFns } from "./DeterCerrado.vue?vue&type=template&id=33de09a8&lang=pug"
import script from "./DeterCerrado.vue?vue&type=script&lang=js"
export * from "./DeterCerrado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports